import type { ReactNode } from "react";
import { Box } from "../../Box";
import { Text } from "../../Text";
import { CopyableValue } from "../CopyableValue";
import { Field, FieldActions, HelperRow } from "./shared";

export function CopyableField({
  label,
  action,
  badge,
  hint,
  value,
}: {
  label: string;
  action?: ReactNode;
  badge?: ReactNode;
  hint?: string;
  value: string;
}) {
  return (
    <Field>
      <Box horizontal={8} vertical={10}>
        <Text variant="text-small-md">{label}</Text>
      </Box>
      <CopyableValue value={value}>
        <Text
          variant="text-regular"
          color="var(--text-secondary)"
          style={{ flex: 1 }}
        >
          {value}
        </Text>
        {badge}
      </CopyableValue>
      {(hint || action) && (
        <HelperRow>
          {hint && (
            <Text variant="text-small" color="var(--text-secondary)">
              {hint}
            </Text>
          )}
          {action && <FieldActions>{action}</FieldActions>}
        </HelperRow>
      )}
    </Field>
  );
}
